import FooterCopyright from './FooterCopyright.vue';
import BlockTitle from './BlockTitle.vue';
import ListSearchbar from './ListSearchbar.vue';
import ListTable from './ListTable.vue';
import BatchUpload from './BatchUpload.vue';
import FormDg from './FormDg.vue';
import TipDg from './TipDg.vue';
import DgWrap from './DgWrap.vue';
import VideoUploadDgBody from './VideoUploadDgBody.vue';
import MyElPopconfirm from './MyElPopconfirm.vue';
import FileIcon from './FileIcon.vue';
import CrumbNav from './CrumbNav.vue';
import  CustomTag  from './CustomTag.vue'
import VDistpicker from 'v-distpicker'

import TestReport from './TestReport.vue'

import DialogTable from './DialogTable.vue'
import VolumeMicrophone from './VolumeMicrophone.vue'
import MathQuillEditor from './MathQuillEditor.vue';
import TwoListSearch from './TwoListSearch.vue'
import PreviewVideoList from './PreviewVideoList.vue'
import Microphone from './Microphone.vue'
import CustromInfo from './custromInfo.vue'
export default {
  install: (Vue) => {
    Vue.component('CustromInfo', CustromInfo);
    Vue.component('Microphone', Microphone);
    Vue.component('PreviewVideoList', PreviewVideoList);
    Vue.component('TwoListSearch', TwoListSearch);
    Vue.component('CustomTag', CustomTag);
    Vue.component('VolumeMicrophone', VolumeMicrophone);
    Vue.component('FooterCopyright', FooterCopyright);
    Vue.component('BlockTitle', BlockTitle);
    Vue.component('ListSearchbar', ListSearchbar);
    Vue.component('ListTable', ListTable);
    Vue.component('BatchUpload', BatchUpload);
    Vue.component('FormDg', FormDg);
    Vue.component('TipDg', TipDg);
    Vue.component('DgWrap', DgWrap);
    Vue.component('VideoUploadDgBody', VideoUploadDgBody);
    Vue.component('VDistpicker', VDistpicker);
    Vue.component('MyElPopconfirm', MyElPopconfirm);
    Vue.component('FileIcon', FileIcon);
    Vue.component('CrumbNav', CrumbNav);
    Vue.component('TestReport', TestReport);
    Vue.component('DialogTable', DialogTable);
    Vue.component('MathQuillEditor', MathQuillEditor);
    // Vue.component('i-title', CustomTitle);
    // Vue.component('AliVerify', AliVerify);
    // Vue.component('AliVerifyMb', AliVerifyMb);
    // Vue.component('MyDatePanel', MyDatePanel);
  },
};
// import CustomTitle from './Title.vue';
// import AliVerify from './AliVerify.vue';
// import AliVerifyMb from './AliVerifyMb.vue';

// import MyDatePanel from './MyDatePanel.vue';
